import React, { useState } from 'react'
import './App.css';
import Navbar from './components/Navbar';
import News from './components/News';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoadingBar from "react-top-loading-bar";

const App = () => {
    let pagesize = 9;
    const apikey = process.env.REACT_APP_APIKEY;
    const [showBanner, setShowBanner] = useState(true);


    const [progress, setprogress] = useState(0);
    const settheprogress = (progress) => {
        setprogress(progress)
    }

    return (
        <BrowserRouter>
            <div>
                {showBanner && (

                    <div
                        className="position-fixed top-3 end-0 m-8 p-3 text-dark border rounded shadow"
                        style={{ margin:'70px 10px', width: '250px', zIndex: 1050, backgroundColor: 'rgb(251 237 189)', position: 'sticky', fontSize: '13px' }}>

                        <div className="d-flex justify-content-between align-items-start">
                            <div>
                                <strong>Note:</strong><br />
                                If you see the date as <strong>17th June 2025</strong>, there may be an issue with the API limit.<br />
                                <br></br>
                                Sorry for the inconvenience.
                            </div>
                            <button
                                className="btn-close"
                                onClick={() => setShowBanner(false)}
                            ></button>
                        </div>
                    </div>
                )}

                <div
                    style={{
                        transform: 'scale(0.8)',
                        transformOrigin: 'top left',
                        width: '125%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        margin: 0,
                        padding: 0,
                    }}
                >

                    <div className="App">

                        <Navbar />

                        <LoadingBar
                            color="#f11946"
                            progress={progress}
                        />
                        <Routes>
                            <Route exact path='/' element={<News setProgress={settheprogress} apikey={apikey} key={"general"} pagesize={pagesize} category="general" country="us" />} />
                            <Route exact path='/business' element={<News setProgress={settheprogress} apikey={apikey} key={"business"} pagesize={pagesize} category="business" country="us" />} />
                            <Route exact path='/entertainment' element={<News setProgress={settheprogress} apikey={apikey} key={"entertainment"} pagesize={pagesize} category="entertainment" country="us" />} />
                            <Route exact path='/general' element={<News setProgress={settheprogress} apikey={apikey} key={"general"} pagesize={pagesize} category="general" country="us" />} />
                            <Route exact path='/health' element={<News setProgress={settheprogress} apikey={apikey} key={"health"} pagesize={pagesize} category="health" country="us" />} />
                            <Route exact path='/science' element={<News setProgress={settheprogress} apikey={apikey} key={"science"} pagesize={pagesize} category="science" country="us" />} />
                            <Route exact path='/sports' element={<News setProgress={settheprogress} apikey={apikey} key={"sports"} pagesize={pagesize} category="sports" country="us" />} />
                            <Route exact path='/technology' element={<News setProgress={settheprogress} apikey={apikey} key={"technology"} pagesize={pagesize} category="technology" country="us" />} />
                        </Routes >

                    </div >

                </div>
            </div>
        </BrowserRouter>
    );
}

export default App